module.exports = __webpack_public_path__ + "static/tara-logo-blanc-efea10dd6bbc3acbb84cdf44f69889a5.svg";